/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {handleCopyModalResult} from '../common/util/handle-copy-modal-result';
import {ToastrService} from 'ngx-toastr';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {wireModelCommsModelActions} from '../common/controller/model-comms-actions';
import {OrderCopyModalComponent} from './order-copy-modal.component';
import template from './order-context-actions.component.html';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-order-context-actions',
  template
})
export class OrderContextActionsComponent implements OnChanges {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;
  @Input() readOnly: boolean;

  readonly confirmation = {
    warningMessage: "The {{action}} of the Order will also stop any of the Order's Line Items from serving ads.",
    object: 'Order'
  };

  constructor(
    private readonly $state: StateService,
    private readonly toastr: ToastrService,
    private readonly angularModalService: AngularModalService
  ) {
  }

  ngOnChanges(): void {
    if (this.model && this.modelComms) {
      wireModelCommsModelActions(this.modelComms);
    }
  }

  copy(): void {
    if (this.readOnly || !this.model) {
      return;
    }

    const modalRef = this.angularModalService.show(OrderCopyModalComponent, {
      initialState: {model: this.model}
    });
    (modalRef.content as any).onCopied.subscribe((result: any) => {
      handleCopyModalResult(() => {
        if (result.destination) {
          this.$state.go('app.adv.orders.order', {id: result.model.id}, {inherit: false});
        } else {
          this.toastr.success('A copy of this order was successfully created.', 'Order Copied');
        }
      });
    });
  }
}
